// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MediaIcon_wrapper__fmhG5"};